<template>
  <div class="lesson-form popup-form">
    <div class="lesson-form__content">
      <div class="lesson-form__content__left">
        <v-date-picker
          v-model="date"
          mode="datetime"
          is24hr
          :minute-increment="15"
          class="time-picker"
          :valid-hours="{ min: 8, max: 21 }"
        />
        <vs-checkbox
          class="lesson__check-repeat"
          v-model="repeat"
          @change="updateModelHandler"
          >Repeat lesson</vs-checkbox
        >
        <div class="lesson__repeat" v-if="repeat">
          <div class="repeat__option inline">
            <vs-input
              label="Every"
              v-model="interval"
              class="repeat-interval"
              @change="updateModelHandler"
            ></vs-input>
            <vs-select
              label="Period"
              v-model="freq"
              @change="updateModelHandler"
            >
              <vs-select-item value="daily" text="day" />
              <vs-select-item value="weekly" text="week" />
              <vs-select-item value="monthly" text="month" />
            </vs-select>
          </div>
          <div class="repeat__option">
            <label for="">Until</label>
            <vs-select v-model="untilType" @change="updateModelHandler">
              <vs-select-item
                value="month"
                :text="`End of ${$moment(now).format('MMMM')}`"
              />
              <vs-select-item value="group" text="End of group" />
              <vs-select-item value="year" text="End of year" />
              <vs-select-item value="custom" text="Custom date" />
            </vs-select>

            <v-date-picker
              v-if="untilType == 'custom'"
              v-model="until"
              mode="date"
            />
          </div>
          <!-- <div class="repeat__option">
            <label for="">Total count to create</label>
            <vs-input size="large" v-model="count" @change="updateModelHandler"></vs-input>
          </div> -->
        </div>
        <div class="field">
          <label for="">Room</label>
          <v-select
            label="name"
            :options="roomsByBranch"
            v-model="room"
            :reduce="(item) => item.id"
            autocomplete="on"
            clearable
            placeholder="Select room"
            :class="{ error: !$v.room.required }"
            @input="updateModelHandler"
          >
            <template #option="{ name, icon }">
              <vs-icon :icon="icon"></vs-icon>
              {{ name }}
            </template>
            <template #selected-option="{ name, icon }">
              <vs-icon :icon="icon"></vs-icon>
              {{ name }}
            </template>
          </v-select>
          <div v-if="!$v.room.required" class="error">Field is required</div>
        </div>
        <div class="field">
          <label for="online">Lesson is online</label>
          <vs-switch
            id="online"
            v-model="is_online"
            @change="updateModelHandler"
          >
            <span slot="on">Online</span>
            <span slot="off">Offline</span>
          </vs-switch>
        </div>
      </div>
      <div class="inline-part right">
        <vs-input
          icon="search"
          size="large"
          placeholder="Search teacher"
          v-model="searchTeacherText"
          class="teacher-search"
        ></vs-input>
        <h3>Main teacher</h3>
        <div v-if="!$v.teacher.required" class="error">Field is required</div>
        <div class="main-teachers">
          <div
            class="teacher-select-block main-teacher"
            v-for="t in searchedTeachers"
            :key="t.id"
            :class="{ selected: t.id == teacher }"
            @click="selectMainTeacherHandler(t.id)"
          >
            <teacher-with-busy :teacher="t">{{ t.nickname }}</teacher-with-busy>
          </div>
        </div>

        <div class="other-teachers collapsible">
          <div class="lesson-item-header" :class="{ otherOpened: otherOpened }">
            <div
              class="collapsible__button"
              @click="otherOpened = !otherOpened"
            >
              <vs-icon
                icon="chevron_right"
                class="small-button collapsible__button__arrow"
                color="dark"
              ></vs-icon>
              <h3>Sub teachers</h3>
            </div>
            <div class="collapsible_content" v-if="otherOpened">
              <div class="main-teachers">
                <div
                  class="teacher-select-block main-teacher"
                  v-for="t in searchedTeachers"
                  :key="t.id"
                  :class="{ selected: otherTeachers.includes(t.id) }"
                  @click="selectOtherTeachersHandler(t.id)"
                >
                  <teacher-with-busy :teacher="t">
                    {{ t.nickname }}</teacher-with-busy
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="assistants collapsible">
          <div
            class="lesson-item-header"
            :class="{ assistantsOpened: assistantsOpened }"
          >
            <div
              class="collapsible__button"
              @click="assistantsOpened = !assistantsOpened"
            >
              <vs-icon
                icon="chevron_right"
                class="small-button collapsible__button__arrow"
                color="dark"
              ></vs-icon>
              <h3>Assistants</h3>
            </div>
            <div class="collapsible_content" v-if="assistantsOpened">
              <div class="main-teachers">
                <div
                  class="teacher-select-block main-teacher"
                  v-for="t in searchedTeachers"
                  :key="t.id"
                  :class="{ selected: assistants.includes(t.id) }"
                  @click="selectAssistantsHandler(t.id)"
                >
                  <teacher-with-busy :teacher="t">
                    {{ t.nickname }}
                  </teacher-with-busy>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="actions">
      <vs-button
        class="save-button"
        icon="save"
        @click="save"
        :disabled="submitDisabled"
        >Save</vs-button
      >
      <vs-button
        class="cancel-button"
        icon="close"
        color="#f1f1f1"
        @click="cancelHandler"
        :disabled="submitDisabled"
        >Cancel</vs-button
      >
    </div> -->
    <!-- <vs-textarea label="comment" v-model="comment"></vs-textarea> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import TeacherWithBusy from '../common/elements/teacherWithBusy.vue'

export default {
  name: 'GeneralLessonForm',
  model: {
    prop: 'modelValue',
    event: 'input',
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    lessonType: {
      type: String,
      default: 'tutor',
    },
    startDate: {
      type: Date,
      default: () => new Date(),
    },
    lessonDuration: {
      type: Number,
      default: 60,
    },
    schoolyear_id: {
      type: Number,
    },
    groupFinish: {
      type: Date,
    },
    // -- TODO: comment
    lessonId: Number,
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    group: Object,
    branch_id: {
      type: Number,
    },
  },
  components: {
    vSelect,
    TeacherWithBusy,
  },
  data() {
    const now = new Date()
    let data = {
      proxy: process.env.VUE_APP_PROXY,
      date: this.startDate,
      lessonName: '', // заполняется пользователем для инд.занятий
      name: '',
      student: [],
      teacher: '',
      room: '',
      id: this.lessonId,
      price: null,
      repeat: false,
      interval: 1,
      freq: 'weekly',
      until: now,
      untilType: 'year',
      count: null,
      index: null,
      now,
      selectedSchoolyearId: null,
      isMultipleStudentToSelect: this.lessonType == 'tutor' ? false : true,
      otherTeachers: [],
      assistants: [],
      is_online: false,
      otherOpened: false,
      assistantsOpened: false,
      searchTeacherText: '',
      teachersWithBusy: [],
      roomsByBranch: [],
    }

    // Инициализация из modelValue (v-model) или groupLesson для обратной совместимости
    const source =
      this.modelValue && Object.keys(this.modelValue).length > 0
        ? this.modelValue
        : this.groupLesson

    if (source) {
      let {
        id,
        student,
        teacher,
        room,
        date,
        price,
        until,
        freq,
        count,
        interval,
        repeat,
        index,
        untilType,
        is_online,
        other_teachers,
        assistants,
      } = source

      date = !date ? this.startDate : (date *= 1000)
      freq = freq || data.freq
      until = until ? new Date(until * 1000) : data.until
      untilType = untilType || data.untilType
      count = count || data.count
      interval = interval || data.interval
      let selectedSchoolyearId = source.schoolyear_id
        ? source.schoolyear_id
        : this.currentYear
        ? this.currentYear.id
        : this.schoolyear_id

      Object.assign(data, {
        date: new Date(date),
        until,
        id,
        student,
        teacher,
        room,
        price,
        freq,
        count,
        interval,
        repeat: repeat || false,
        index,
        untilType,
        selectedSchoolyearId,
        is_online,
        otherTeachers: other_teachers || [],
        assistants: assistants || [],
      })
    }

    return data
  },
  watch: {
    date: async function (oldV, newV) {
      // оставляем обновление даты через watch,
      // так как пикер не поддерживает события обновления (change)
      if (oldV != newV) {
        await this.getTeacherBusyHandler()
        this.emitUpdate()
      }
    },
    until: async function (oldV, newV) {
      // оставляем обновление даты через watch,
      // так как пикер не поддерживает события обновления (change)
      if (oldV != newV) {
        this.emitUpdate()
      }
    },
    branch_id: function (newV) {
      if (this.rooms) {
        this.roomsByBranch = this.rooms.filter((r) => r.branch.id == newV)
      }
      this.roomsByBranch = []
    },
    untilType: function () {
      switch (this.untilType) {
        case 'month':
          this.until = this.$moment().endOf('month').unix()
          break
        case 'group':
          this.until = this.groupFinish
            ? this.groupFinish.getTime()
            : this.currentYear.date_end_unix
          break
        case 'year':
          // until = null;
          this.until = this.currentYear.date_end_unix
          break
        case 'custom':
          this.until = this.until.getTime()
      }
    },
  },
  computed: {
    ...mapState({
      teachers: (state) => state.teachers.teachers,
      rooms: (state) => state.rooms.rooms,
      students: (state) => state.students.students,
      years: (state) => state.years.years,
      currentYear: (state) => state.years.currentSchoolYear,
    }),
    searchedTeachers: function () {
      if (this.searchTeacherText) {
        return this.teachersWithBusy.filter((t) =>
          t.nickname
            .toLowerCase()
            .includes(this.searchTeacherText.toLowerCase())
        )
      }
      return this.teachersWithBusy
    },
  },
  validations: {
    teacher: {
      required,
    },
    room: {
      required,
    },
  },
  methods: {
    syncFromModel(newVal) {
      // Синхронизация внутренних данных при изменении modelValue извне
      let {
        id,
        student,
        teacher,
        room,
        date,
        price,
        until,
        freq,
        count,
        interval,
        repeat,
        index,
        untilType,
        is_online,
        other_teachers,
        assistants,
      } = newVal

      date = !date ? this.startDate : (date *= 1000)
      until = until ? new Date(until * 1000) : this.until

      this.$set(this, 'id', id)
      this.$set(this, 'student', student || [])
      this.$set(this, 'teacher', teacher)
      this.$set(this, 'room', room)
      this.$set(this, 'date', new Date(date))
      this.$set(this, 'price', price)
      this.$set(this, 'until', until)
      this.$set(this, 'freq', freq || this.freq)
      this.$set(this, 'count', count)
      this.$set(this, 'interval', interval || this.interval)
      this.$set(this, 'repeat', repeat || false)
      this.$set(this, 'index', index)
      this.$set(this, 'untilType', untilType || this.untilType)
      this.$set(this, 'is_online', is_online)
      this.$set(this, 'otherTeachers', other_teachers || [])
      this.$set(this, 'assistants', assistants || [])

      this.emitUpdate()
    },

    emitUpdate: function () {
      // Эмитировать обновление modelValue для v-model связи
      const lesson = this._buildLessonObject()
      this.$emit('input', lesson)
    },

    _buildLessonObject: function () {
      // -- добавляем данные для совместимости

      return {
        id: this.id,
        lessonName: this.lessonName,
        date: this.date ? Math.floor(this.date.getTime() / 1000) : null,
        duration: this.lessonDuration,
        repeat: this.repeat,
        count: this.count ? parseInt(this.count, 10) : null,
        interval: this.interval ? parseInt(this.interval, 10) : 1,
        teacher: this.teacher,
        room: this.room,
        until: this.until
          ? this.until instanceof Date
            ? Math.floor(this.until.getTime() / 1000)
            : this.until
          : null,
        freq: this.freq,
        price: this.price,
        untilType: this.untilType,
        schoolyear_id: this.selectedSchoolyearId,
        other_teachers: this.otherTeachers,
        assistants: this.assistants,
        is_online: this.is_online,
        index: this.index,
        student: this.student,
        day: this.date ? this.date.getDay() : null,
        name: this.date ? this.$moment(this.date).format('ddd') : null,
        time: this.date ? this.$moment(this.date).format('HH:mm') : null
      }
    },

    cancelHandler: function () {
      this.$emit('closeHandler')
    },
    save: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      let {
        id,
        date,
        repeat,
        count,
        interval,
        untilType,
        until,
        teacher,
        room,
        student,
        lessonType,
        index,
        name,
        lessonName,
        freq,
        price,
        lessonDuration,
        selectedSchoolyearId,
        otherTeachers,
        assistants,
        is_online,
      } = this

      switch (untilType) {
        case 'month':
          until = this.$moment().endOf('month').unix()
          break
        case 'group':
          until = this.groupFinish
            ? this.groupFinish.getTime() / 1000
            : this.currentYear.date_end_unix
          break
        case 'year':
          // until = null;
          until = this.currentYear.date_end_unix
          break
        case 'custom':
          until = this.until.getTime() / 1000
      }

      // Обновляем until после пере计算
      this.$set(this, 'until', until)

      // Эмитируем обновление через v-model
      this.emitUpdate()

      const lesson = {
        id,
        lessonName,
        date: date.getTime() / 1000,
        duration: lessonDuration,
        repeat,
        count: count ? parseInt(count, 10) : null,
        interval: interval ? parseInt(interval, 10) : 1,
        teacher,
        room,
        until,
        freq,
        price,
        untilType,
        other_teachers: otherTeachers,
        assistants,
        is_online,
      }

      if (lessonType == 'tutor' || lessonType == 'testing') {
        lesson.lesson_type = lessonType
        lesson.student = student
        lesson.name = name
        lesson.schoolyear_id =
          selectedSchoolyearId || this.currentYear.id || this.schoolyear_id
      }
      if (typeof index !== 'undefined') lesson.index = index
      // -- добавляем данные для совместимости
      lesson.day = date.getDay()
      lesson.name = this.$moment(date).format('ddd')
      lesson.time = this.$moment(date).format('HH:mm')
      // --
      this.$emit('saveLesson', lesson)
    },
    timeChangeHandler: function () {
      // При изменении даты/времени сразу обновляем modelValue
      this.emitUpdate()
    },
    getTeacherBusyHandler: async function () {
      setTimeout(async () => {
        await this.$store
          .dispatch('teachers/getTeachersBusyAction', {
            schoolyear_id: this.selectedSchoolyearId,
            week_day: this.date.getDay(),
            time: this.$moment(this.date).format('HH:mm'),
          })
          .then((data) => {
            this.teachersWithBusy = [...this.teachers]
            if (data) {
              const busyData = { ...data }
              this.teachersWithBusy = this.teachersWithBusy.map((t) => {
                let busy = busyData[t.id]
                if (busy) {
                  t.busy = busy
                } else {
                  t.busy = {}
                }
                return t
              })
            }
          })
      }, 100)
    },
    selectMainTeacherHandler: function (teacher_id) {
      this.teacher = teacher_id
      this.emitUpdate()
    },
    selectOtherTeachersHandler: function (teacher_id) {
      if (this.otherTeachers.includes(teacher_id)) {
        this.otherTeachers.splice(
          this.otherTeachers.findIndex((t) => t == teacher_id),
          1
        )
      } else {
        this.otherTeachers.push(teacher_id)
      }
      this.emitUpdate()
    },
    selectAssistantsHandler: function (teacher_id) {
      if (this.assistants.includes(teacher_id)) {
        this.assistants.splice(
          this.assistants.findIndex((t) => t == teacher_id),
          1
        )
      } else {
        this.assistants.push(teacher_id)
      }
      this.emitUpdate()
    },
    updateModelHandler: function () {
      this.emitUpdate()
    },
  },
  created: async function () {
    if (!this.selectedSchoolyearId && this.currentYear.id) {
      this.selectedSchoolyearId = this.currentYear.id
    }
    await this.getTeacherBusyHandler()
    if (this.branch_id) {
      this.roomsByBranch = this.rooms.filter(
        (r) => r.branch.id == this.branch_id
      )
    }
  },
}
</script>

<style lang="scss">
.lesson-form {
  &__content {
    display: flex;
    flex-flow: row nowrap;
    gap: 10px;
    align-items: flex-start;
    &__left {
      width: 35%;
      .time-picker {
        margin: 5px 0;
        width: 100%;
      }
      .lesson__check-repeat {
        margin-top: 15px;
      }
      .lesson__repeat {
        padding: 10px;
        background-color: #eee;
        border-radius: 10px;
        .repeat__option {
          display: flex;
          flex-flow: column nowrap;

          & > * {
            margin: 5px;
          }
          &.inline {
            display: flex;
            flex-flow: row nowrap;
          }
          .repeat-interval {
            max-width: 5em;
            .vs-input--input.normal {
              padding: 0.6rem;
            }
          }
        }
      }
    }
  }

  .actions {
    position: sticky;
    bottom: 0;
    left: 0;
    display: flex;
    padding: 15px;
    .vs-button {
      float: none;
      margin-right: 10px;
    }
    .cancel-button {
      color: var(--font-color);
      z-index: 101;
    }
  }
  .main-teachers {
    display: flex;
    flex-flow: row wrap;
    gap: 5px;
  }
  .teacher-select-block {
    padding: 3px;
    border-radius: 7px;
    border: 1px solid var(--table-disabled-bcg);
    font-size: 0.8rem;
    transition: all 0.2s;
    cursor: pointer;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    &:hover {
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
        rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    }
    &.selected {
      border-color: var(--font-primary-color);
      box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
        rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
        rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
      font-weight: bold;
    }
  }
  .other-teachers,
  .assistants {
    margin-top: 1rem;
  }
  .teacher-search {
    width: 100%;
    margin-bottom: 0.5rem;
    margin-top: 0;
  }
}
</style>
